import { Component } from '@verndale/core';

class InstallationStepsRow extends Component {
  setupDefaults() {
    this.dom = {
      steps: this.el.querySelectorAll('.installation-steps-row__step'),
      showAllButton: this.el.querySelector<HTMLElement>(
        '.installation-steps-row__see-more'
      )
    };
  }

  addListeners() {
    (this.dom.showAllButton as HTMLElement)?.addEventListener(
      'click',
      this.showAllSteps.bind(this)
    );
  }

  showAllSteps() {
    (this.dom.steps as NodeListOf<HTMLElement>).forEach(step => {
      step.style.display = 'list-item';
    });
    (this.dom.showAllButton as HTMLElement).style.display = 'none';
  }
}

export default InstallationStepsRow;
